<template>
    <footer class="footer">
        <div class="container-fluid">

            <brand-footer :show-version="true"></brand-footer>

            <div class="copyright">
                © {{year}}
                <a href="http://fraysse.eu" target="_blank">Sébastien Fraysse</a>
            </div>

        </div>
    </footer>
</template>

<script>
    export default {
        data() {
            return {
                year: new Date().getFullYear()
            }
        }
    };
</script>
